// import React from "react";
// import ReactDOM from "react-dom";
// import "./Styles/index.css";
// import './i18n';

// import Rotas from "./Routes/routes"

// ReactDOM.render(<Rotas/>, document.getElementById("root"));



import React from "react";
import ReactDOM from "react-dom/client";   
import "./Styles/index.css";
import "./i18n";
import { initializeIcons } from "@fluentui/react/lib/Icons";
import Rotas from "./Routes/routes";

initializeIcons(); 

const root = ReactDOM.createRoot(document.getElementById("root")); 

root.render(
  // <React.StrictMode>
    <Rotas />
  // </React.StrictMode>
);